import type { CameraApiResponse } from "@src/services/api/cameras-api";
import { getCameraDisplayName, getCameraKeyString, getSiteString } from "@src/utils/key-parser";

export type CameraSortOption = "id" | "nickname" | "name" | "site";

export function sortCameras(
  cameras: CameraApiResponse[],
  sortBy: CameraSortOption[] | CameraSortOption,
): CameraApiResponse[] {
  const options = Array.isArray(sortBy) ? sortBy : [sortBy];
  if (options.length === 0) return cameras;

  const sorted = [...cameras];
  sorted.sort((a, b) => {
    for (const option of options) {
      const result = compareByOption(a, b, option);
      if (result !== 0) return result;
    }
    return 0;
  });
  return sorted;
}

export function compareByOption(a: CameraApiResponse, b: CameraApiResponse, option: CameraSortOption): number {
  const aKey = getCameraKeyString(a);
  const bKey = getCameraKeyString(b);

  switch (option) {
    case "id":
      return aKey.localeCompare(bKey);
    case "nickname": {
      const aName = a.nickname || getCameraDisplayName(aKey) || aKey;
      const bName = b.nickname || getCameraDisplayName(bKey) || bKey;
      return aName.localeCompare(bName);
    }
    case "name": {
      const aName = a.name ?? getCameraDisplayName(aKey) ?? aKey;
      const bName = b.name ?? getCameraDisplayName(bKey) ?? bKey;
      return aName.localeCompare(bName);
    }
    case "site": {
      const aSite = getSiteString(a);
      const bSite = getSiteString(b);
      if (aSite !== bSite) {
        return aSite.localeCompare(bSite);
      }
      return aKey.localeCompare(bKey);
    }
  }
}
